//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingIndicator from 'app/components/LoadingIndicator';
import { usePaymentState } from 'payment_state/PaymentStateContext';

const ShopifyUiPage = () => {
  const location = useLocation();
  const [scriptLoaded, setScriptLoaded] = useState(false); // 스크립트 로드 상태 관리
  const params = new URLSearchParams(location.search);
  const queryObject = {};

  const openPaymentUi = () => {
    if (window.payVerse && typeof window.payVerse.requestUI === 'function') {
      // window.payVerse가 존재하고 requestUI가 함수일 경우에만 호출
      window.payVerse.requestUI(
        queryObject,
        val => (window.location.href = queryObject.cancelUrl),
      );
    }
  };

  // 스크립트가 로드되었는지 확인하는 함수
  const checkScriptLoaded = () => {
    if (window.payVerse && typeof window.payVerse.requestUI === 'function') {
      return true;
    }
    return false;
  };

  useEffect(() => {
    // 스크립트가 로드되었는지 확인
    const interval = setInterval(() => {
      if (checkScriptLoaded()) {
        clearInterval(interval); // 스크립트 로드 확인되면 interval 해제
        setScriptLoaded(true); // 상태 업데이트
      }
    }, 100); // 100ms마다 체크 (상황에 맞게 조정 가능)

    return () => clearInterval(interval); // cleanup
  }, []);

  useEffect(() => {
    if (scriptLoaded) {
      // 쿼리 파라미터를 queryObject로 설정
      params.forEach((value, key) => {
        queryObject[key] = value;
      });
      openPaymentUi(); // 스크립트 로드 완료 후 UI 호출
    }
  }, [scriptLoaded]); // scriptLoaded가 true일 때만 openPaymentUi 실행

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <LoadingIndicator />
    </div>
  );
};

export default ShopifyUiPage;
